
import React, {Component} from 'react';
import { Box } from 'reactjs-admin-lte'
import FontAwesome from 'react-fontawesome'
import { Button } from 'react-bootstrap'
import AssetDoc from './AssetDoc'
import AssetStore from 'stores/AssetStore'
import AssetToolBar from '../tyre/report-asset-vehicle-page/AssetToolBar'
import {connect} from 'react-redux'
class ReportAssetPage extends Component {

  constructor(...args){
    super(...args)
    this.state = {
      data:[],
      loading:false,
      showTb:true,
      asset_id:'',
      action:'',
    }
  }

  componentDidMount() {
    this.loadData()
  }

  componentWillReceiveProps(newProps) {
    if (newProps.showTbReportAssetPage) {
      this.setState({showTb:newProps.showTbReportAssetPage})
      this.loadData()
    }
  }

  loadData() {
    this.setState({loading:true})
    AssetStore.loadReportAsset((result)=>{
      this.setState({loading:false,data:result.data})
    })
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  onNewClick() {
    this.setState({showTb:false,action:'add',asset_id:''})
    this.props.onShowTabs(false)
  }

  onRowSelect(item) {
    this.setState({showTb:false,action:'',asset_id:item.asset_id})
    this.props.onShowTabs(false)
    this.props.onRowSelect(item)
  }

  onDocClose() {
    this.loadData() 
    this.setState({showTb:true,action:'',asset_id:''})
    this.props.onShowTabs(true)
  }

  onAssetSerach(new_asset) {
    this.setState({data:new_asset})
  }

  renderRowData() {
    let {data} = this.state
    if (data.length===0) {
        return(<tr><td colSpan={8}>ไม่พบข้อมูล</td></tr>)
    } else {
        return(
          data.map((item,index)=>
              <tr onClick={this.onRowSelect.bind(this,item)} key={index}>
                  <td className='text-center'>{index+1}</td>
                  <td className='text-center'>{item.asset_code}</td>
                  <td className='text-center'>{item.serial_no}</td>
                  <td className='text-left'>{item.detail}</td>
                  <td className='text-center'></td>
                  <td className='text-center'>{item.asset_type}</td>
                  <td className='text-center'>{item.vehicle_registration_no}</td>
                  <td className='text-center'>{item.location}</td>
              </tr>
          )
        )
    }
  }

  renderTable() {
    return(
      <div className='table-responsive'>
        <table className='table table-bordered-solid table-hover'>
            <thead>
                <tr>
                    <th className='text-center' style={{minWidth:'50px',width:'50px'}}>ลำดับ</th>
                    <th className='text-center' style={{minWidth:'120px',width:'120px'}}>รหัสสินทรัพย์</th>
                    <th className='text-center' style={{minWidth:'120px',width:'120px'}}>รหัสซีเรียล</th>
                    <th className='text-center' style={{minWidth:'150px',width:'150px'}}>ชื่อรายการ</th>
                    <th className='text-center' style={{minWidth:'100px',width:'100px'}}>หน่วยนับ</th>
                    <th className='text-center' style={{minWidth:'90px',width:'90px'}}>ประเภท</th>
                    <th className='text-center' style={{minWidth:'100px',width:'100px'}}>ทะเบียนรถ</th>
                    <th className='text-center' style={{minWidth:'100px',width:'100px'}}>ชั้นวาง</th>
                </tr>    
            </thead>
            <tbody>
                {this.renderRowData()}
            </tbody>        
        </table>
      </div>
    )
  }

  render(){
    let {loading,showTb,action} = this.state
    return (
      <div>
        <div style={{display:(showTb?'':'none')}}>
          <Box loading={loading}>
            <Box.Header border={true}>
              <Box.Title>ตารางรายงานสินทรัพย์</Box.Title>
              <Box.Tools>
                <Button 
                  onClick={this.onNewClick.bind(this)}
                  bsStyle={'link'}
                  className='text-large'
                >
                  <FontAwesome name='plus' />&nbsp;เพิ่มสินทรัพย์
                </Button>
              </Box.Tools>
            </Box.Header>
            <Box.Body>
              <AssetToolBar
                onSerach={this.onAssetSerach.bind(this)}
              />
              {this.renderTable()}
            </Box.Body>                
          </Box>
        </div>
        <div style={{display:(showTb?'none':'')}}>
          <AssetDoc
            onClose={this.onDocClose.bind(this)}
            showTb={showTb}
            assetId={this.state.asset_id}
            action={action}
          />
        </div>
      </div>
    )
  }
}

export default ReportAssetPage = connect(
  (state) => ({messages: state.message.view.asset.ReportAssetPage}),null,null,{withRef:true}
)(ReportAssetPage);





// WEBPACK FOOTER //
// ./src/view/asset/ReportAssetPage.js